import { DataTable } from './data-table'
import { columns } from './columns'
import { useGetAllUsers } from '../../../api/routes/users'

export const UsersRoute = () => {
    const { data: users, isLoading } = useGetAllUsers()

    if (isLoading) {
        return (
            <div className="mx-auto py-6 lg:py-10 px-4 sm:px-6 lg:px-8 xl:px-32">
                <div className="animate-pulse space-y-4">
                    <div className="h-7 w-32 bg-muted rounded" />
                    <div className="h-10 w-full sm:w-80 bg-muted rounded-lg" />
                    <div className="h-64 bg-muted rounded-lg" />
                </div>
            </div>
        )
    }

    return (
        <div className="mx-auto py-6 lg:py-10 px-4 sm:px-6 lg:px-8 xl:px-32">
            <div className="mb-6">
                <h1 className="text-2xl font-semibold tracking-tight text-foreground">
                    Users
                </h1>
                <p className="text-sm text-muted-foreground mt-1">
                    {users?.length || 0} user{users?.length !== 1 ? 's' : ''}{' '}
                    registered
                </p>
            </div>
            <DataTable columns={columns} data={users ?? []} />
        </div>
    )
}
